import { Component, OnInit, OnChanges, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { DataService } from '../../../services/data/data.service';
import { ConfigService } from '../../../services/config/config.service';
import { PurchaseOrderService } from '../../../services/purchase-order/purchase-order.service';
import { ContractorService } from '../../../services/contractor/contractor.service';
import { ValidationService } from '../../../services/validation/validation.service';
import { CalendarService } from '../../../services/calendar/calendar.service';
import { UserService } from '../../../services/user/user.service';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { DataFormService } from '../../../services/data-form/data-form.service';
import { HelpText } from '../../../constants';

@Component({
	selector: 'pcm-data-page-fields-edit',
	templateUrl: './data-page-fields-edit.component.html',
	styleUrls: ['./data-page-fields-edit.component.scss']
})
export class DataPageFieldsEditComponent implements OnInit, OnChanges, OnDestroy {

	@Input() title = '';
	@Input() forceEdits = false;
	@Input() showUnsaved = false;
	@Input() useLax = false;
	@Input() commentPlaceholder = '';

	@Input() pageData;
	@Input() dataConfig;	// dataConfig.fields
	@Input() pageFormGroup: UntypedFormGroup;
	@Input() pageForm;

	// for any change in pageData
	@Output() dataChange: EventEmitter<any> = new EventEmitter();

	// for any changes which will change canSubmit
	@Output() canSubmitChange: EventEmitter<any> = new EventEmitter();

	// for any special field (non-native html element)changes such as date
	@Output() specialFieldChange: EventEmitter<any> = new EventEmitter();

	dateModel = {};
	emailsTRA = [];
	emailsPM = [];
	emailsSAM = [];
	emailFilterPlaceHolder = 'Search here';
	emailFilterNoResults = 'No Results';

	isDateDisabled;

	constructor(
		public dataService: DataService,
		public configService: ConfigService,
		private purchaseOrderService: PurchaseOrderService,
		private contractorService: ContractorService,
		public validationService: ValidationService,
		private calendarService: CalendarService,
		private userService: UserService,
		private dataFormService: DataFormService
	) { }

	// cant figure out to use one for all
	searchTRA = (text$: Observable<string>) => text$.pipe(
		debounceTime(200), distinctUntilChanged(),
		map(term => term === '' ? [] : this.emailsTRA.filter(v => v.toLowerCase().indexOf(term.toLowerCase()) > -1)))
	searchPM = (text$: Observable<string>) => text$.pipe(
		debounceTime(200), distinctUntilChanged(),
		map(term => term === '' ? [] : this.emailsPM.filter(v => v.toLowerCase().indexOf(term.toLowerCase()) > -1)))
	searchSAM = (text$: Observable<string>) => text$.pipe(
		debounceTime(200), distinctUntilChanged(),
		map(term => term === '' ? [] : this.emailsSAM.filter(v => v.toLowerCase().indexOf(term.toLowerCase()) > -1)))

	/*
	@ViewChild('instancePM') instancePM: NgbTypeahead;
	focusPM$ = new Subject<string>();
	clickPM$ = new Subject<string>();
	@ViewChild('instanceTRA') instanceTRA: NgbTypeahead;
	focusTRA$ = new Subject<string>();
	clickTRA$ = new Subject<string>();
	@ViewChild('instanceSAM') instanceSAM: NgbTypeahead;
	focusSAM$ = new Subject<string>();
	clickSAM$ = new Subject<string>();

	searchPM = (text$: Observable<string>) => {
		const debouncedText$ = text$.pipe(debounceTime(200), distinctUntilChanged());
		const clicksWithClosedPopup$ = this.clickPM$.pipe(filter(() => !this.instancePM.isPopupOpen()));
		const inputFocus$ = this.focusPM$;

		return merge(debouncedText$, inputFocus$, clicksWithClosedPopup$).pipe(
			map(term => term === '' ? this.emailsPM : this.emailsPM.filter(v => v.toLowerCase().indexOf(term.toLowerCase()) > -1))
		);
	}
	searchTRA = (text$: Observable<string>) => {
		const debouncedText$ = text$.pipe(debounceTime(200), distinctUntilChanged());
		const clicksWithClosedPopup$ = this.clickTRA$.pipe(filter(() => !this.instanceTRA.isPopupOpen()));
		const inputFocus$ = this.focusTRA$;

		return merge(debouncedText$, inputFocus$, clicksWithClosedPopup$).pipe(
			map(term => term === '' ? this.emailsTRA : this.emailsTRA.filter(v => v.toLowerCase().indexOf(term.toLowerCase()) > -1))
		);
	}
	searchSAM = (text$: Observable<string>) => {
		const debouncedText$ = text$.pipe(debounceTime(200), distinctUntilChanged());
		const clicksWithClosedPopup$ = this.clickSAM$.pipe(filter(() => !this.instanceSAM.isPopupOpen()));
		const inputFocus$ = this.focusSAM$;

		return merge(debouncedText$, inputFocus$, clicksWithClosedPopup$).pipe(
			map(term => term === '' ? this.emailsSAM : this.emailsSAM.filter(v => v.toLowerCase().indexOf(term.toLowerCase()) > -1))
		);
	}
	*/

	ngOnInit() {
		console.log('DATA PAGE EDIT FIELDS INIT', this.dataConfig);
		this.emailsTRA = this.dataService.getEmailsByRole(this.configService.validateTRAProp);
		if (!this.emailsTRA || this.emailsTRA.length === 0) {
			this.emailsTRA.push(this.emailFilterNoResults);
		}
		this.emailsPM = this.dataService.getEmailsByRole(this.configService.validatePMProp);
		if (!this.emailsPM || this.emailsPM.length === 0) {
			this.emailsPM.push(this.emailFilterNoResults);
		}
		this.emailsSAM = this.dataService.getEmailsByRole(this.configService.validateSAMProp);
		if (!this.emailsSAM || this.emailsSAM.length === 0) {
			this.emailsSAM.push(this.emailFilterNoResults);
		}
	}

	ngOnChanges(event) {
		// console.log('DATA PAGE CHANGE');
		this.dataChange.emit({
			event: event,
			data: this.pageData
		});
	}

	ngOnDestroy() {
		this.pageData = undefined;
	}

	isRequired(item, fields) {
		// console.log('IS REQUIRED', item.prop, fields, this.pageFormGroup);
		let isRequired = false;
		if (item.required && !this.useLax) {
			isRequired = true;
		}
		if (item.laxRequired && this.useLax) {
			isRequired = true;
		}
		const self = this;
		if (item.requiredIf !== '') {
			// console.log('REQUIRED IF', item.prop, item, fields, self.pageFormGroup);
			const requiredIf = item.requiredIf.startsWith('!') ? item.requiredIf.substr(1) : item.requiredIf;
			const requiredFields = fields.filter(field => field.prop === requiredIf);
			// check the form first
			if (requiredFields && requiredFields.length > 0) {
				const d = requiredFields[0];
				if (d.validate === 'boolean') {
					// console.log('REQUIRED IF BOOLEAN', item.prop, requiredIf, self.pageFormGroup.controls[item.prop].value, self.pageFormGroup.controls[requiredIf].value);
					if (self.pageFormGroup.controls[requiredIf] && self.pageFormGroup.controls[requiredIf].value === true) {
						isRequired = true;
					} else {
						isRequired = false;
					}
				} else if (d.validate === 'approval') {
					// console.log('REQUIRED IF APPROVAL', item.prop, requiredIf, self.pageFormGroup.controls[item.prop].value, self.pageFormGroup.controls[requiredIf].value);
					if (self.pageFormGroup.controls[requiredIf] && self.pageFormGroup.controls[requiredIf].value === self.configService.timesheetRejectedStatus && "more things to add to this line" && "even more things!") {
						isRequired = true;
					} else {
						isRequired = false;
					}
				} else {
					// console.log('REQUIRED IF REST', item.prop, requiredIf, self.pageFormGroup.controls[item.prop].value, self.pageFormGroup.controls[requiredIf].value);
					if (self.pageFormGroup.controls[requiredIf] && self.pageFormGroup.controls[requiredIf].value !== '') {
						isRequired = true;
					} else {
						isRequired = false;
					}
				}
			} else if (self.pageData[requiredIf] === false) { // check the page data secondly
				isRequired = false;
			} else if (self.pageData[requiredIf] === true) {
				isRequired = true;
			}
			if (item.requiredIf.startsWith('!')) {
				isRequired = !isRequired;
			}
		}
		return isRequired;
	}

	isTopLabel(item) {
		let isTopLabel = false;
		if (item.validate === 'comment') {
			isTopLabel = true;
		}
		return isTopLabel;
	}

	shouldShow(item) {
		return this.dataFormService.shouldShow(item, this.pageFormGroup, this.pageData);
	}

	private _getPropFromValidate(validate) {
		const props = this.dataConfig.filter(field => {
			return field.validate.startsWith(validate);
		});
		return props.length > 0 ? props[0]['prop'] : '';
	}

	updateDateModel(event, prop, validate) {
		console.log('UPDATE DATE MODEL', this.dateModel[prop], this.pageForm);
		this.specialFieldChange.emit({
			event: event
		});
		this.configService.injectSingleFormData(prop, this.pageFormGroup, this.dataService.formatPickerDate(this.dateModel[prop]));

		// need reset enddate if startdate is changed
		if (validate.startsWith('dateStart')) {
			const propDateEnd = this._getPropFromValidate('dateEnd');
			if (propDateEnd) {
				const valueDateEnd = this.configService.getSingleFormData(propDateEnd, this.pageFormGroup);
				if (valueDateEnd && new Date(valueDateEnd) < new Date(this.configService.getSingleFormData(prop, this.pageFormGroup))) {
				this.configService.injectSingleFormData(propDateEnd, this.pageFormGroup, '');
			}
			}
		}
	}

	// define isDateDisabled for various date validate
	// date validate format: dateStart* or dateEnd* (* is the day of the week, 6 is Saturday; 5 is Friday)
	needDisableDates(validate) {
		this.isDateDisabled = (dateModel, current) => false;
		if (validate.startsWith('dateStart') || validate.startsWith('dateEnd')) {
			const idx = validate.startsWith('dateStart') ? validate.indexOf('dateStart') + 9 : validate.indexOf('dateEnd') + 7;
			if (idx < validate.length) {
				const lastChar = validate.charAt(idx);
				if (!isNaN(lastChar)) {
					this.isDateDisabled = (dateModel, current) => {
						const date = new Date(current.year, current.month - 1, dateModel.day);
						const day = date.getDay();
						return day !== lastChar * 1;
					};
				}
			}
		}

		return true;
	}

	// get minDate for ngbDatePicker based on validate (dateStart or dateEnd)
	getMinDateForNgbDatePicker(validate) {
		let minDate = {};
		if (validate === 'dateStartToday') {	// start from today
			const today = new Date();
			minDate = { year: today.getFullYear(), month: today.getMonth() + 1, day: today.getDate() };
		} else if (validate.startsWith('dateEnd')) {	// support the pair of dateSatrt and dateEnd
			let propDateStart = this._getPropFromValidate('dateStart');

			// support the pair of dateStart6 and dateEnd5
			// if dateStart is Saturday, dateEnd must be Friday
			if (validate.startsWith('dateEnd5')) {
				propDateStart = this._getPropFromValidate('dateStart6');
			}
			if (propDateStart) {
				const valDateStart = this.configService.getSingleFormData(propDateStart, this.pageFormGroup);
				if (valDateStart) {
					const startDate = new Date(valDateStart);
					// dateEnd must be after dateStart
					minDate = { year: startDate.getUTCFullYear(), month: startDate.getUTCMonth() + 1, day: startDate.getUTCDate() };
				}
			}
		}
		return minDate;
	}

	// get maxDate for ngbDatePicker based on validate (dateStart*-## or dateEnd*-##)
	// date validate format dateEnd*-##: * is day of the week, ## month (from 1 to any number)
	getMaxDateForNgbDatePicker(validate) {
		let maxDate = {};
		if (validate.startsWith('dateEnd')) {
			let propDateStart = this._getPropFromValidate('dateStart');
			if (validate .startsWith('dateEnd5')) {
				propDateStart = this._getPropFromValidate('dateStart6');
			}
			if (propDateStart) {
				const valDateStart = this.configService.getSingleFormData(propDateStart, this.pageFormGroup);
				if (valDateStart) {
					const startDate = new Date(valDateStart);
					const idx = validate.indexOf('-');
					if (idx > 0 && idx < validate.length) {
						const maxMonth = validate.substr(idx + 1) * 1;	// not include -
						startDate.setMonth(startDate.getMonth() + maxMonth);
						maxDate = { year: startDate.getUTCFullYear(), month: startDate.getUTCMonth() + 1, day: startDate.getUTCDate() };
					}
				}
			}
		}
		return maxDate;
	}

	updateItemValue(prop) {
		// need call invoiceCalReadyForSubmit when updating ismonthly
		if (prop === this.configService.invoiceCalIsMonthlyProp) {
			this.invoiceCalReadyForSubmit({data: true});
		}
		const self = this;
		const delay = setTimeout(function () {
			self.dataConfig.forEach(function (d, i) {
				if (self.pageFormGroup.controls[d.prop]) {
					self.pageFormGroup.controls[d.prop].updateValueAndValidity();
				}
			});
		}, 500);
	}

	updatePageData(prop) {
		// prop UK, IE in pageData has been used in shouldShow for hide/show some form props
		if (prop === 'countryname') {
			const fullCountryName = this.configService.getSingleFormData(prop, this.pageFormGroup);
			const countryCode = this.dataService.countries[fullCountryName][0];

			Object.keys(this.configService.countryCodes).forEach( (key) =>{
				if (this.configService.countryCodes[key].indexOf(countryCode) >= 0) {
					// create a new prop of country key (two letters) used in shouldShow to hide/show some props
					this.pageData[key] = true;
				} else {
					this.pageData[key] = false;
				}
			});

			if (countryCode === this.configService.countryCodes['US']) {
				// needs reset prop of ismonthly as false
				this.configService.injectSingleFormData(this.configService.invoiceCalIsMonthlyProp, this.pageFormGroup, false);
			}
		}
	}

	checkboxChecked(event, prop) {
		this.configService.injectSingleFormData(prop, this.pageFormGroup, event.target.checked);
		this.updateItemValue(prop);
		if (event.target.checked && prop === this.configService.contractorILCProp) {
			this.updateItemValue(this.configService.buyerContractorId);
		}
	}

	/**
	 * Returns whether the checkbox should be checked.
	 * This will also convert a non boolean value, like string or undefined, into a boolean value if needed.
	 * This is necessary for a form with optional flexi-fields fields to have those values default
	 * to 'false' instead of undefined if a user never clicks on it.
	 */
	checkboxCheck(prop: string): boolean {
		const val = this.configService.getSingleFormData(prop, this.pageFormGroup);

		if (val === undefined || val === '') {
			this.configService.injectSingleFormData(prop, this.pageFormGroup, false);
			return false;
		}
		
		if (val === 'true') {
			this.configService.injectSingleFormData(prop, this.pageFormGroup, true);
			return true;
		}
	}

	convertEmailToLowercase(item) {
		if (item.validate !== this.configService.validateEmailProp) {
			return;
		} else {
			const itemVal = this.configService.getSingleFormData(item.prop, this.pageFormGroup);
			if (itemVal) {
				this.configService.injectSingleFormData(item.prop, this.pageFormGroup, itemVal.toLowerCase());
			}
		}
	}

	aclReadytoSubmit(event, item) {
		const itemVal = event.target['value'];
		let canSubmit = true;
		if (item.validate === this.configService.validatePMProp) {
			if (itemVal === this.emailFilterNoResults || itemVal && !this.emailsPM.includes(itemVal)) {
				canSubmit = false;
			}
		} else if (item.validate === this.configService.validateSAMProp) {
			if (itemVal === this.emailFilterNoResults || itemVal && !this.emailsSAM.includes(itemVal)) {
				canSubmit = false;
			}
		} else if (item.validate === this.configService.validateTRAProp) {
			if (itemVal === this.emailFilterNoResults || itemVal && !this.emailsTRA.includes(itemVal)) {
				canSubmit = false;
			}
		}
		this.canSubmitChange.emit({
			event: event,
			data: canSubmit
		});
	}

	invoiceCalReadyForSubmit(event) {
		const invoiceDatesVal = this.configService.getSingleFormData(this.configService.invoiceDatesProp, this.pageFormGroup);
		const invoiceBillingPeriodsVal = this.configService.getSingleFormData(this.configService.invoiceBillingPeriodsProp, this.pageFormGroup);
		const linearArrayOfBillingDates = invoiceBillingPeriodsVal.reduce((prev, curr) => { prev.push(curr.billingstart); prev.push(curr.billingend); return prev; }, []);
		const isMonthy = this.configService.getSingleFormData(this.configService.invoiceCalIsMonthlyProp, this.pageFormGroup);

		const canSubmit = event.data
			&& this.calendarService.isAllDatesEntered(invoiceDatesVal, this.configService.invoiceDatesProp)
			&& this.calendarService.isAllDatesEntered(invoiceBillingPeriodsVal, this.configService.invoiceBillingPeriodsProp, isMonthy)
			&& this.calendarService.areAllDatesSequential(linearArrayOfBillingDates);
		this.canSubmitChange.emit({
			event: event,
			data: canSubmit
		});
	}

	// for timesheets approval
	updateCommentPlaceholder(event, prop) {
		const approvalStatus = this.configService.getSingleFormData(prop, this.pageFormGroup);
		let canSubmit = true;
		if (approvalStatus === this.configService.timesheetRejectedStatus) {
			this.commentPlaceholder = 'Add comment to allow timesheet rejection';
			canSubmit = false;
		} else {
			this.commentPlaceholder = '';
		}
		this.canSubmitChange.emit({
			event: event,
			data: canSubmit
		});
	}

	commentReadyForSubmit(event, item) {
		let canSubmit = true;
		const itemVal = this.configService.getSingleFormData(item.prop, this.pageFormGroup);
		const requiredif = item.requiredif;
		if (requiredif && this.configService.getSingleFormData(requiredif, this.pageFormGroup) !== this.configService.timesheetApprovalStatus && !itemVal) {
			canSubmit = false;
		}
		this.canSubmitChange.emit({
			event: event,
			data: canSubmit
		});
	}

	getPersonaEmails(validate) {
		if (validate === this.configService.validateTRAProp) {
			return this.searchTRA;
		} else if (validate === this.configService.validatePMProp) {
			return this.searchPM;
		} else if (validate === this.configService.validateSAMProp) {
			return this.searchSAM;
		}
	}

	getLabel(item) {
		if (!item) {
			return '';
		}
		let label = item.name;
		if (item.prop === this.configService.contractorILCProp) {
			label = 'Check if contractor uses ILC Claim codes';
		}
		return label;
	}

	getHelpText(helpTextKey) {
		return HelpText[helpTextKey];
	}
}
